export default __webpack_public_path__ + "static/media/fonacate_8a-congresso_logo.dd7b1cc2.png";